export default __webpack_public_path__ + "static/media/carfax-icon.348fb8d2.png";